import PropTypes from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { crearRequerimiento } from "../../services/requerimientos-service";
import { selectSoftware } from "../../services/software-service";

const FormRequerimientos = ({ modalState, onSave }) => {
    const [software, setSoftware] = useState([]);

    useEffect(async () => {
        const resp = await selectSoftware();
        if (!resp.status) return toast.error(resp.message);

        setSoftware(
            resp.data.map((software) => {
                return {
                    label: software.nombre,
                    value: software.id,
                };
            })
        );
    }, []);

    const form = useForm();

    const onCreateRequerimientos = async (requerimiento) => {
        const resp = await crearRequerimiento({
            ...requerimiento,
            software_id: requerimiento.software_id.value,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formRequerimientos"
            isOpen={modalState.show}
            onSubmit={onCreateRequerimientos}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        type="text"
                        label="Nombre requerimientos"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        placeholder="Nombre requerimientos"
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="software_id"
                        label="Software"
                        control={form.control}
                        options={software}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <InputController
                        type="textarea"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        placeholder="Descripción"
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="textarea"
                        label="Caracteristicas"
                        errors={form.formState.errors}
                        control={form.control}
                        name="caracteristicas"
                        placeholder="Caracteristicas"
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormRequerimientos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormRequerimientos;
